import { render, staticRenderFns } from "./galleryMobile.vue?vue&type=template&id=6e830d1c&scoped=true"
import script from "./galleryMobile.vue?vue&type=script&lang=js"
export * from "./galleryMobile.vue?vue&type=script&lang=js"
import style0 from "./galleryMobile.vue?vue&type=style&index=0&id=6e830d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e830d1c",
  null
  
)

export default component.exports